<template>
    <div class="information-default">
        <img src="../../assets/sucesso.png" alt="" class="success-image">
        <span class="title-success" :attr="title">{{ title }}</span>
        <button-game v-if="button" :name="nameButton" typeLogin="email" :action="action"></button-game>
    </div>
</template>
<script>
import ButtonGame from '../Buttons/ButtonGame'
import Bus from '@/main.js'
export default {
    components : {
        ButtonGame
    },
    created(){
        Bus.$on(`${this.action}`, this.redirectButton)
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    destroyed(){
        Bus.$off(`${this.action}`, this.redirectButton)
    },
    methods: {
        redirectButton(){
            this.$router.push(`/${this.action}`)
        }
    },
    props : {
        nameButton : {
            type : String,
            required : true
        },
        action : {
            type : String,
            required : true
        },
        title : {
            type : String,
            required : true
        },
        button : {
            type : Boolean,
            default: true
        }
    }
}
</script>
<style lang="scss" scoped>
    .information-default{
        width: 85%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;

        .success-image{

            height: 170px;
            margin-top: 30px;
        }

        .title-success{

            letter-spacing: 2px;
            text-transform: uppercase;
            font-weight: 700;
            font-size: 15px;
            color: #30353a;
            text-align: center;
            margin-top: 50px;
        }
    }
</style>
